import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import SuccessAlert from "./../child/Alert/SuccessAlert";
import DengerAlert from "./../child/Alert/DengerAlert";
import Loader from "./../child/Loder";
import { getDiscountDetail } from "../../services/discountService";
import moment from "moment";
import { formatApiDate } from "../../utils/dateHelper";

const getTotalUseCount = (item) => {
  const value =
    item?.totalUseCount ??
    item?.totalUsed ??
    item?.total_used ??
    item?.total_use_count ??
    0;
  const num = Number(value);
  return Number.isFinite(num) ? num : 0;
};

/** API key: discountType — values: flatfee | percentage */
const getDiscountType = (item) => {
  const raw = String(
    item?.discountType ?? item?.discountype ?? item?.discount_type ?? "",
  )
    .toLowerCase()
    .replace(/[\s_-]/g, "");
  if (raw === "flatfee" || raw.includes("flat")) return "flatfee";
  if (raw === "percentage" || raw.includes("percent")) return "percentage";
  return "";
};

const formatDiscountTypeLabel = (type) => {
  if (type === "flatfee") return "Flat Fee";
  if (type === "percentage") return "Percentage";
  return "N/A";
};

const formatDiscountValue = (item) => {
  if (item?.discount == null || item?.discount === "") return "N/A";
  const type = getDiscountType(item);
  if (type === "flatfee") return `$${item.discount}`;
  if (type === "percentage") return `${item.discount}%`;
  return item.discount;
};

const ViewDiscountPageNew = () => {
  const [itemData, setItemData] = useState(null);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await getDiscountDetail(id);
        const payload = res?.data || {};
        const data =
          payload.result || payload.data || payload.discount || payload;
        setItemData(data);
      } catch (err) {
        setErrorMessage("Failed to fetch discount detail.");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id]);

  if (loading) return <Loader />;
  return (
    <div className="row gy-4">
      {successMessage && (
        <SuccessAlert
          message={successMessage}
          onClose={() => setSuccessMessage("")}
        />
      )}
      {errorMessage && (
        <DengerAlert
          message={errorMessage}
          onClose={() => setErrorMessage("")}
        />
      )}
      <div className="col-md-12">
        <div className="card h-100">
          <div className="card-body p-24">
            <div className="row">
              <div className="col-md-2 mb-3">
                <label className="form-label fw-bold">Code</label>
                <div>{itemData?.code || "N/A"}</div>
              </div>
              <div className="col-md-2 mb-3">
                <label className="form-label fw-bold mt-2">Discount Type</label>
                <p>{formatDiscountTypeLabel(getDiscountType(itemData))}</p>
              </div>
              <div className="col-md-2 mb-3">
                <label className="form-label fw-bold mt-2">Discount</label>
                <p>{formatDiscountValue(itemData)}</p>
              </div>
              <div className="col-md-2 mb-3">
                <label className="form-label fw-bold mt-2">Total Used</label>
                <p>{getTotalUseCount(itemData)}</p>
              </div>
              <div className="col-md-2 mb-3">
                <label className="form-label fw-bold mt-2">Start Date</label>
                <p>
                  {formatApiDate(itemData?.startDate)}
                </p>
              </div>
              <div className="col-md-2 mb-3">
                <label className="form-label fw-bold mt-2">End Date</label>
                <p>
                  {formatApiDate(itemData?.endDate)}
                </p>
              </div>
              <div className="col-md-2 mb-3">
                {itemData?.type === "host" && (
                  <>
                    <label className="form-label fw-bold mt-2">Host By</label>
                    <p>{itemData?.userId?.fullName || "N/A"}</p>
                  </>
                )}
              </div>
            </div>

            <div className="col-md-12">
              <label className="form-label fw-bold mt-2">Description</label>
              <p>{itemData?.description || "N/A"}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewDiscountPageNew;
